import React from 'react';
import check from '../../../assets/icons/Vector (8).svg';

export const ModalSteps = ({ steps, currentStep, onStepClick, }) => {
  return (
    <div className="d-flex justify-content-center">
      <ul className="list-unstyled d-flex" style={{ flexDirection: 'column', gap: '20px' }}>
        {steps?.map((step, index) => (
          <li
            key={index}
            className="step-item flex-fill text-center"
            style={{ display: 'flex', gap: '10px', cursor:'pointer'  }}
            // onClick={() => isEditMode && onStepClick?.(index)} // ✅ only clickable in edit mode
             onClick={() =>  onStepClick?.(index)} 
          >
            <div
              className={`step-circle ${index < currentStep ? 'completed' : ''} ${
                index === currentStep ? 'active' : ''
              }`}
            >
              {index < currentStep ? <img src={check} alt="done" /> : ''}
            </div>
            <div
              className={`text-steps ${
                index < currentStep ? 'text-muted-steps' : ''
              } ${index === currentStep ? 'text-primary-steps' : ''}`}
            >
              {step}
            </div>

            {index < steps.length - 1 && (
              <div
                className={`step-line ${index < currentStep ? 'completed' : ''} ${
                  index === currentStep ? 'active' : ''
                }`}
              ></div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
